<template>
  <i class="icon_wrap"></i>
</template>

<script>
export default {
  name: 'Light'
};
</script>

<style scoped lang="stylus">
.icon_wrap {
  display inline-block
  width 24px
  height 24px
  background-size 24px 24px
  background-repeat no-repeat
  background-position center
  background-image url('./images/mine_collect_icon_sel_selected@3x.png')
}
</style>
